import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Landmark, Clock, CheckCircle, AlertCircle, ArrowRight, Check } from 'lucide-react';
import { fetchPageBySlug, fetchGalleryBySlug } from '../lib/api';
import Lightbox from '../components/Lightbox';

const EMPLOYEES = [
  {
    name: "Søren Pedersen",
    role: "Indehaver og leder af værksted",
    phone: "(+45) 21 47 61 46",
    phoneRaw: "21476146",
    email: "soren@dan-team.com",
    image: "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/fbe78a2e-4a10-4385-9cb1-ddc4710fee35.png"
  },
  {
    name: "Martin Vedel Bindesbøl",
    role: "Indehaver og montage supervisor",
    phone: "(+45) 25 21 45 29",
    phoneRaw: "25214529",
    email: "martin@dan-team.com",
    image: "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/6164dda9-c7ba-4987-81ab-d0021490fefa.png"
  },
  {
    name: "Bogholderi",
    phone: "(+45) 76 99 10 20",
    phoneRaw: "76991020",
    email: "info@dan-team.com",
    image: "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/c869aa7b-42ba-4282-977e-72edff13f3a4.png"
  }
];

const SPECIAL_PAGES_DATA = {
  vaerkstedet: {
    title: "Værkstedet",
    subtitle: "Vi sætter en ære i altid at levere vores produkter nøjagtig tilpasset kundens ønsker og behov og ikke mindst at overholde den aftalte deadline.",
    heroImage: "https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/mixtanke-klar-til-afsendelse-til-dansk-ingenoerfirma.jpg",
    row1: {
      title: "Vores værksted",
      text: [
        "DAN-TEAM Stainless har siden 2010 haft værksted i Sjølund lidt syd for Kolding.",
        "I 2015 flyttede vi til nyere lyse lokaler på Kurkmarkvej 6, stadig i Sjølund.",
        "På vores fuldt udstyrede værksted, bliver du mødt af en flok dygtige og engagerede medarbejdere, som alle er uddannede i branchen og som løbende uddannes, så de altid har gældende certifikater og godkendelser. Vores stab består af 5-7 smede og to lærlinge. Vi sætter en ære i altid at levere vores produkter nøjagtig tilpasset kundens ønsker og behov og ikke mindst at overholde den aftalte deadline.",
        "Vores opgaver spænder bredt, fra et beslag som en montør skal bruge ude på en montage og til nøglefærdige units klar til produktion. Ens for alle opgaver is, at vi altid sikrer at kvaliteten altid er i top."
      ],
      image: "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/image_3.png"
    },
    row2: {
      title: "Vi er med fra første ide",
      text: [
        "En af vores kerne kompetencer er at vi hjælper kunden hele vejen fra ide og design, til produktion af det færdige produkt.",
        "Gennem vore mange år i branchen har vi opbygget et stort know-how indenfor fremstilling og produktion af udstyr til fødevareindustrien.",
        "Vi hjælper ofte vore kunder med blandt andet, ide og design, tegningsarbejde, gennemgang af projekter inden opstart med henblik på optimering af fremstillingsprocesser, materialevalg mm.",
        "Udover DAN-TEAM Stainless egne kompetencer, har vi et stort netværk af underleverandører og samarbejdspartnere, som vi har samarbejdet med gennem mange år og som kender vores krav til kvalitet, dette gælder bl.a.:"
      ],
      image: "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/image_5.png",
      checklist: [
        "3D-tegning",
        "Laserskæring",
        "Maskinbearbejdning af emner i alle udformninger",
        "Overfladebehandling af rustfrit stål; slibning, polering, bejdsning og glasblæsning"
      ],
      outroText: [
        "Priser\nKontakt os for et uforpligtende tilbud på din næste opgave."
      ]
    },
    galleryTitle: "Billedgalleri fra værkstedet",
    gallerySubtitle: "Se et udvalg af vores arbejde og færdige produkter fremstillet på vores værksted."
  },
  montageafd: {
    title: "Montageafdelingen",
    subtitle: "DAN-TEAM har mere end 20 års erfaring i montage af procesanlæg i de forskellige industrier.",
    heroImage: "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/a61c6976-2ded-460b-a358-b6f3edb3dd8f.jpg",
    row1: {
      title: "Vores montageafdeling",
      text: [
        "DAN-TEAM har mere end 20 års erfaring i montage af procesanlæg i de forskellige industrier samt gennemførelsen af både store og små montagearbejder.",
        "Vores erfarne montører og supervisorer udfører nybyg, flytninger og renoveringer af alle typer af procesindustri og det især procesanlæg for fødevarer og den kemiske industri.",
        "På baggrund af kundens anlægsspecifikationer og tegningsmateriale giver vi gerne en fast pris på opgaven, men for mindre montage- og vedligeholdelsesopgaver kan det afregnes som timelønsarbejde.",
        "Ofte har kunden også brug for vores hjælp igennem processen med ideer, know-how og planlægning af opgaven. Vi har fast tegner tilknyttet huset, som vi har haft samarbejde med gennem mange år og som har en rigtig stor viden indenfor vores område.",
        "DAN-TEAM Stainless stiller med et team af dygtige supervisorer, montører og svejsere, der alle er udstyret med tidssvarende værktøj, udstyr og alle de påkrævede certifikater. Vi arrangerer gerne selv rejser og ophold for vores montører og supervisorer – både nationalt og internationalt. Ved større montageprojekter medbringer vi en montagecontainer, der fungerer som et mobilt værksted samt som frokost faciliteter for vores medarbejdere."
      ],
      image: "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/b3d62c9e-7350-42f0-9fe3-0e1d8aedbb8b.jpg"
    },
    row2: {
      sections: [
        {
          title: "Supervision",
          text: [
            "Til de opgaver, hvor kunden ønsker at benytte egne montører, kan Dan-Team Stainless tilbyde assistance fra vores dygtige supervisorer. Supervisoren leder og gennemfører montagearbejdet på basis af flowdiagrammer og arrangementstegninger, så kunden ikke selv skal bruge unødig tid på projektering og udarbejdelse af detaljerede tegninger. Vores supervisorer er danskere og taler alle engelsk og tysk."
          ]
        },
        {
          title: "Flytninger",
          text: [
            "DAN-TEAM Stainless har foretaget flere flytninger af komplette procesanlæg f.eks. fra et land til et andet.",
            "Når vi har ansvaret for montageentreprisen, skal kunden ikke bekymre sig om små detaljer i forbindelse med arbejdet, dem har vi styr på."
          ]
        }
      ],
      image: "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/image_6.png"
    },
    galleryTitle: "Billedgalleri fra montageafdelingen",
    gallerySubtitle: "Se et udvalg af vores montagearbejde og projekter udført i ind- og udland."
  },
  vandskaering: {
    title: "Vandskæring",
    subtitle: "Fordelene ved vandstråleskæring er, at mange emner kan anvendes direkte fra skæreprocessen uden nogen videre efterbearbejdning.",
    heroImage: "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/67dab333-1d05-448c-b845-f04bf23c83c8.jpeg",
    row1: {
      title: "Vandskæring – et tryk på 4000 bar",
      text: [
        "Har du brug for vandskæring/vandstråleskæring, kan vi være behjælpelig, Vi har udført vandskæring for en bred vifte af kunder fra hele Danmark, der tæller både private og erhverv.",
        "Teknologien bag Abrasiv vandskæring tager udgangspunkt i højtrykspumpen, her bliver vandet tilført et tryk på 4000 bar. Ved skærehovedet bliver der tilsat et fint slibemiddel, derved kan der vådslibes gennem stort set alle materialer.",
        "Fordelene ved vandstråleskæring er, at mange emner kan anvendes direkte fra skæreprocessen uden nogen videre efterbearbejdning.",
        "Kræves der derimod en efterbearbejdning, er der ingen hærdede zoner, som slider meget på skærende værktøjer.",
        "Skæreprocessen er “kold”, dvs. at der ikke sker varmepåvikninger / randzonehærdninger under skæringen.",
        "Det betyder også, at man i mange tilfælde kan skære gevind i skårne huller, uden at skulle bore hullet op først.",
        "Udover stor nøjagtighed er nogle af fordelene ved vandskæring, at man opnår en konkurrencedygtig og miljøvenlig løsning samt ingen eller minimal afgratning."
      ],
      image: "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/image_8.png"
    },
    row2: {
      title: "Næsten ingen begrænsninger",
      text: [
        "Udover stor nøjagtighed er nogle af fordelene ved vandskæring, at man opnår en konkurrencedygtig og miljøvenlig løsning samt ingen eller minimal afgratning.",
        "Vi tilbyder vandskæring af følgende materialer:"
      ],
      image: "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/image_9.png",
      checklist: [
        "Rustfrit stål",
        "Aluminium",
        "Kobber",
        "Messing",
        "Zink",
        "Titan",
        "Keramik",
        "Beton",
        "Gummi",
        "Plast",
        "Glasfiber",
        "Vinyl",
        "Træ",
        "Glas",
        "Dit materiale..??"
      ],
      checklistGrid: false,
      outroText: [
        "Programmer til vandstråleskæring udarbejdes på baggrund af papirstegninger, eller kundens pdf, dxf, stp eller dwg filer.",
        "Kontakt vedr. Vandskæring, soren@dan-team.com"
      ]
    },
    galleryTitle: "Billedgalleri fra vandskæring",
    gallerySubtitle: "Se eksempler på præcisionsarbejde udført med vores avancerede vandskærer."
  }
};

export default function PageDetail() {
  const { slug } = useParams();
  const pageSlug = slug || 'index';

  const [page, setPage] = useState(null);
  const [gallery, setGallery] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Lightbox State
  const [lightboxIndex, setLightboxIndex] = useState(null);

  // Form State (for kontakt page)
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    description: '',
    website_url: '' // Honeypot
  });
  const [formStatus, setFormStatus] = useState({ type: null, message: '' });
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    async function loadPageData() {
      setLoading(true);
      const data = await fetchPageBySlug(pageSlug);
      setPage(data);

      // Check if page has associated gallery
      const hasGallery = ['vaerkstedet', 'montageafd', 'vandskaering', 'referencer', 'om-os'].includes(pageSlug);
      if (hasGallery) {
        const galleryImages = await fetchGalleryBySlug(`gallery-${pageSlug}`);
        setGallery(galleryImages);
      } else {
        setGallery([]);
      }

      setLoading(false);
    }
    loadPageData();
  }, [pageSlug]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setFormStatus({ type: null, message: '' });

    if (!formData.name || !formData.phone || !formData.email || !formData.description) {
      setFormStatus({ type: 'error', message: 'Venligst udfyld alle påkrævede felter.' });
      return;
    }

    setSubmitting(true);

    try {
      const response = await fetch('https://api.dev.auxo.dk/webform/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setFormStatus({
          type: 'success',
          message: 'Mange tak for din henvendelse! Vi vender tilbage til dig hurtigst muligt.'
        });
        setFormData({
          name: '',
          phone: '',
          email: '',
          description: '',
          website_url: ''
        });
      } else {
        throw new Error('Server error');
      }
    } catch (error) {
      console.error('Fejl ved afsendelse af formular:', error);
      setFormStatus({
        type: 'error',
        message: 'Der skete en fejl under afsendelsen. Venligst prøv igen eller kontakt os direkte via telefon.'
      });
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-sky-500"></div>
      </div>
    );
  }

  if (!page) {
    return (
      <div className="min-h-screen bg-white text-slate-900 flex flex-col items-center justify-center px-4 text-center space-y-4">
        <h1 className="text-4xl font-bold uppercase tracking-widest">Siden blev ikke fundet</h1>
        <p className="text-base text-slate-600 max-w-md font-light">Vi kunne desværre ikke finde den side, du leder efter. Venligst tjek URL-adressen eller gå tilbage til forsiden.</p>
        <Link to="/" className="px-8 py-3 bg-sky-500 hover:bg-sky-600 text-white font-bold uppercase tracking-wider transition-all">
          Gå til forsiden
        </Link>
      </div>
    );
  }

  const isKontaktPage = pageSlug === 'kontakt';
  const isSpecialPage = ['vaerkstedet', 'montageafd', 'vandskaering'].includes(pageSlug);

  if (isSpecialPage) {
    const specialData = SPECIAL_PAGES_DATA[pageSlug];
    return (
      <div className="bg-white text-slate-600 min-h-screen">
        {/* Custom Hero Section */}
        <section className="relative min-h-[500px] md:h-[60vh] flex items-center justify-center overflow-hidden">
          <div 
            className="absolute inset-0 bg-cover bg-center bg-no-repeat scale-105"
            style={{ 
              backgroundImage: `url(${specialData.heroImage || page.hero_image?.[0] || 'https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/image_1.png'})` 
            }}
          />
          <div className="absolute inset-0 bg-black/50" />

          <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-8 text-center w-full space-y-6 py-16">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white break-words px-4">
              {specialData.title}
            </h1>
            <p className="text-[28px] text-slate-200 max-w-3xl mx-auto font-light leading-[1.4]">
              {specialData.subtitle}
            </p>
            <div className="flex flex-wrap justify-center gap-4 pt-4">
              <Link 
                to="/kontakt" 
                className="bg-[#0073A5] hover:bg-[#005c84] text-white px-8 py-3.5 text-xs font-bold tracking-widest uppercase transition-colors duration-200"
              >
                Kontakt os
              </Link>
              <Link 
                to="/referencer" 
                className="bg-[#0073A5] hover:bg-[#005c84] text-white px-8 py-3.5 text-xs font-bold tracking-widest uppercase transition-colors duration-200"
              >
                Læs mere
              </Link>
            </div>
          </div>
        </section>

        {/* Two-Column Alternating Content Block */}
        <section className="bg-slate-50 py-16">
          <div className="max-w-[1400px] mx-auto px-6 lg:px-12 space-y-0">
            
            {/* Row 1: Content Block */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 overflow-hidden border border-slate-200/60 shadow-xs bg-white">
              {/* Left Column: Text */}
              <div className="p-8 md:p-16 flex flex-col justify-center space-y-6">
                <h2 className="text-2xl md:text-3xl font-bold text-slate-900 tracking-normal pb-4">
                  {specialData.row1.title}
                </h2>
                <div className="text-slate-600 leading-relaxed text-base space-y-4 font-light">
                  {specialData.row1.text.map((paragraph, pIdx) => (
                    <p key={pIdx}>{paragraph}</p>
                  ))}
                </div>
              </div>
              {/* Right Column: Image */}
              <div className="relative min-h-[350px] lg:min-h-full">
                <img 
                  src={specialData.row1.image} 
                  alt={specialData.row1.title} 
                  className="absolute inset-0 w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Row 2: Content Block */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 overflow-hidden border border-slate-200/60 shadow-xs bg-white">
              {/* Left Column: Image (Desktop first, but on mobile it stacks naturally) */}
              <div className="relative min-h-[350px] lg:min-h-full order-2 lg:order-1">
                <img 
                  src={specialData.row2.image} 
                  alt={specialData.row2.title} 
                  className="absolute inset-0 w-full h-full object-cover"
                />
              </div>
              {/* Right Column: Text */}
              <div className="p-8 md:p-16 flex flex-col justify-center space-y-6 order-1 lg:order-2">
                {specialData.row2.sections ? (
                  <div className="space-y-8">
                    {specialData.row2.sections.map((section, sIdx) => (
                      <div key={sIdx} className="space-y-4">
                        <h2 className="text-2xl md:text-3xl font-semibold text-slate-900 tracking-normal">
                          {section.title}
                        </h2>
                        <div className="text-slate-600 leading-relaxed text-base space-y-4 font-light">
                          {section.text.map((paragraph, pIdx) => (
                            <p key={pIdx}>{paragraph}</p>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <>
                    <h2 className="text-2xl md:text-3xl font-bold text-slate-900 tracking-normal pb-4">
                      {specialData.row2.title}
                    </h2>
                    <div className="text-slate-600 leading-relaxed text-base space-y-4 font-light">
                      {specialData.row2.text.map((paragraph, pIdx) => (
                        <p key={pIdx}>{paragraph}</p>
                      ))}
                    </div>
                  </>
                )}

                {/* Render checklist if present (e.g. for vandskaering) */}
                {specialData.row2.checklist && (
                  <div className="pt-2">
                    <ul className={`grid gap-x-6 gap-y-2 text-slate-600 text-base font-light ${specialData.row2.checklistGrid ? 'grid-cols-2 sm:grid-cols-3' : 'grid-cols-1'}`}>
                      {specialData.row2.checklist.map((item, idx) => (
                        <li key={idx} className="flex items-center gap-2">
                          <Check className="w-4 h-4 text-[#0073A5] shrink-0" />
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                
                <div className="text-slate-600 leading-relaxed text-base space-y-4 font-light">
                  {specialData.row2.outroText && specialData.row2.outroText.map((paragraph, pIdx) => {
                    if (paragraph.includes('soren@dan-team.com')) {
                      const parts = paragraph.split('soren@dan-team.com');
                      return (
                        <p key={pIdx} className="pt-2">
                          {parts[0]}
                          <a href="mailto:soren@dan-team.com" className="text-[#0073A5] font-semibold hover:underline">
                            soren@dan-team.com
                          </a>
                          {parts[1]}
                        </p>
                      );
                    }
                    if (paragraph.startsWith("Priser\n")) {
                      const lines = paragraph.split('\n');
                      const restOfText = lines[1].replace(/^Kontakt os\s*/, '');
                      return (
                        <div key={pIdx} className="pt-4 space-y-1">
                          <h4 className="text-lg font-normal text-slate-800">{lines[0]}</h4>
                          <p className="text-slate-600">
                            <Link to="/kontakt" className="text-[#0073A5] font-bold hover:underline">
                              Kontakt os
                            </Link>
                            {" "}{restOfText}
                          </p>
                        </div>
                      );
                    }
                    return <p key={pIdx} className="pt-2 whitespace-pre-line">{paragraph}</p>;
                  })}
                </div>
              </div>
            </div>

          </div>
        </section>

        {/* Associated Gallery Grid */}
        {gallery.length > 0 && (
          <section className="py-16 max-w-[1400px] mx-auto px-6 lg:px-12">
            <div className="space-y-8">
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
                {gallery.map((img, idx) => (
                  <div 
                    key={idx}
                    onClick={() => setLightboxIndex(idx)}
                    className="aspect-square bg-slate-100 border border-slate-200 overflow-hidden cursor-pointer group relative"
                  >
                    <img 
                      src={img} 
                      alt={`Galleri billede ${idx + 1}`} 
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                      <span className="text-xs text-white uppercase tracking-wider font-semibold bg-sky-950/90 px-4 py-2 border border-sky-900">
                        FORSTØR
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}

        {/* Lightbox for Gallery */}
        {lightboxIndex !== null && (
          <Lightbox
            images={gallery}
            currentIndex={lightboxIndex}
            onClose={() => setLightboxIndex(null)}
            onPrev={() => setLightboxIndex((lightboxIndex - 1 + gallery.length) % gallery.length)}
            onNext={() => setLightboxIndex((lightboxIndex + 1) % gallery.length)}
          />
        )}
      </div>
    );
  }

  if (pageSlug === 'referencer') {
    return (
      <div className="bg-white text-slate-600 min-h-screen">
        {/* Hero Section */}
        <section className="relative min-h-[500px] md:h-[60vh] flex items-center justify-center overflow-hidden">
          <div 
            className="absolute inset-0 bg-cover bg-center bg-no-repeat scale-105"
            style={{ 
              backgroundImage: `url(${page.hero_image?.[0] || 'https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/ddd6ef51-f3db-400f-bf9b-d1d8ddae8c3d.jpg'})` 
            }}
          />
          <div className="absolute inset-0 bg-black/50" />

          <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-8 text-center w-full space-y-6 py-16">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-normal break-words px-4">
              Referencer
            </h1>
            <p className="text-[28px] text-slate-200 max-w-3xl mx-auto font-light leading-[1.4]">
              Siden Dan-Team Stainless startede i 1999 har vi bygget en lang række forskellige procesanlæg for virksomheder.
            </p>
            <div className="flex flex-wrap justify-center gap-4 pt-4">
              <Link 
                to="/kontakt" 
                className="bg-[#0073A5] hover:bg-[#005c84] text-white px-8 py-3.5 text-xs font-bold tracking-widest uppercase transition-colors duration-200"
              >
                Kontakt os
              </Link>
              <Link 
                to="/referencer" 
                className="bg-[#0073A5] hover:bg-[#005c84] text-white px-8 py-3.5 text-xs font-bold tracking-widest uppercase transition-colors duration-200"
              >
                læs mere
              </Link>
            </div>
          </div>
        </section>

        {/* Main Content Section */}
        <section className="py-16 sm:py-24 max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 md:gap-16">
            
            {/* Left Column: Main Content */}
            <div className="space-y-8 lg:col-span-8">
              <div className="space-y-6 text-slate-600 font-light leading-relaxed text-base">
                <h2 className="text-2xl md:text-3xl font-bold text-slate-900 tracking-normal uppercase border-b border-slate-200 pb-2">
                  Vores referencer
                </h2>
                <p>
                  Siden Dan-Team Stainless startede i 1999 har vi bygget en lang række forskellige procesanlæg for virksomheder.
                </p>
              </div>

              {/* Logos Container for Referencer */}
              {gallery.length > 0 && (
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 pt-2">
                  {gallery.map((img, idx) => (
                    <div 
                      key={idx}
                      className="aspect-video bg-white border border-slate-200 flex items-center justify-center p-3 hover:border-slate-300 transition-colors"
                    >
                      <img 
                        src={img} 
                        alt={`Reference logo ${idx + 1}`} 
                        className="max-h-[85%] max-w-[85%] object-contain"
                        loading="lazy"
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Right Column: Sidebar Card */}
            <div className="lg:col-span-4 lg:sticky lg:top-8 self-start">
              <div className="bg-[#f2f2f2] border border-slate-200 overflow-hidden">
                {/* Header Image */}
                <div className="relative h-48 sm:h-56">
                  <img 
                    src="https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/712c627a-a535-4e18-86ad-bc70df05eee5.jpg" 
                    alt="Værksted" 
                    className="w-full h-full object-cover"
                  />
                </div>

                {/* Form & Copy */}
                <div className="p-6 sm:p-8 space-y-6">
                  <div className="space-y-2">
                    <h3 className="text-xl font-bold text-slate-900 uppercase tracking-normal">
                      Få et uforpligtende tilbud
                    </h3>
                    <p className="text-base text-slate-600 font-light leading-relaxed">
                      Kontakt os og få et uforpligtende tilbud på din opgave. Du kan ringe til os på{' '}
                      <a href="tel:+4576991020" className="text-[#0073A5] font-semibold hover:underline">
                        (+45) 76 99 10 20
                      </a>{' '}
                      eller udfylde formularen og vi vil vende tilbage til dig hurtigst muligt.
                    </p>
                  </div>

                  {/* Sidebar Form */}
                  <form onSubmit={handleFormSubmit} className="space-y-4">
                    {/* Honeypot field - ABSOLUTELY HIDDEN from humans */}
                    <div className="sr-only absolute" aria-hidden="true">
                      <label htmlFor="website_url">Website URL</label>
                      <input
                        id="website_url"
                        type="text"
                        name="website_url"
                        value={formData.website_url}
                        onChange={handleInputChange}
                        tabIndex="-1"
                        autoComplete="off"
                      />
                    </div>

                    {/* Name */}
                    <div className="space-y-1">
                      <label htmlFor="name" className="text-[10px] font-bold uppercase tracking-wider text-slate-700">
                        Navn <span className="text-red-500">*</span>
                      </label>
                      <input
                        id="name"
                        type="text"
                        name="name"
                        required
                        value={formData.name}
                        onChange={handleInputChange}
                        className="w-full bg-white border border-slate-300 px-3 py-2 text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-1 focus:ring-sky-500 text-sm"
                        placeholder="Dit navn"
                      />
                    </div>

                    {/* Phone */}
                    <div className="space-y-1">
                      <label htmlFor="phone" className="text-[10px] font-bold uppercase tracking-wider text-slate-700">
                        Telefonnummer <span className="text-red-500">*</span>
                      </label>
                      <input
                        id="phone"
                        type="tel"
                        name="phone"
                        required
                        value={formData.phone}
                        onChange={handleInputChange}
                        className="w-full bg-white border border-slate-300 px-3 py-2 text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-1 focus:ring-sky-500 text-sm"
                        placeholder="Dit telefonnummer"
                      />
                    </div>

                    {/* Email */}
                    <div className="space-y-1">
                      <label htmlFor="email" className="text-[10px] font-bold uppercase tracking-wider text-slate-700">
                        E-mailadresse <span className="text-red-500">*</span>
                      </label>
                      <input
                        id="email"
                        type="email"
                        name="email"
                        required
                        value={formData.email}
                        onChange={handleInputChange}
                        className="w-full bg-white border border-slate-300 px-3 py-2 text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-1 focus:ring-sky-500 text-sm"
                        placeholder="din.email@adresse.dk"
                      />
                    </div>

                    {/* Description */}
                    <div className="space-y-1">
                      <label htmlFor="description" className="text-[10px] font-bold uppercase tracking-wider text-slate-700">
                        Beskrivelse <span className="text-red-500">*</span>
                      </label>
                      <textarea
                        id="description"
                        name="description"
                        required
                        rows="4"
                        value={formData.description}
                        onChange={handleInputChange}
                        className="w-full bg-white border border-slate-300 px-3 py-2 text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-1 focus:ring-sky-500 text-sm resize-none"
                        placeholder="Beskriv dit projekt her..."
                      />
                    </div>

                    {/* Status Messages */}
                    {formStatus.type && (
                      <div className={`p-3 text-xs ${
                        formStatus.type === 'success' 
                          ? 'bg-emerald-500/10 border border-emerald-500/20 text-emerald-600' 
                          : 'bg-red-500/10 border border-red-500/20 text-red-600'
                      }`}>
                        <span>{formStatus.message}</span>
                      </div>
                    )}

                    {/* Submit Button */}
                    <button
                      type="submit"
                      disabled={submitting}
                      className="w-full py-3 bg-[#0073A5] hover:bg-[#005c84] disabled:bg-sky-800 text-white font-bold uppercase text-xs tracking-wider transition-colors duration-200 flex items-center justify-center gap-2 cursor-pointer"
                    >
                      {submitting ? 'Sender...' : 'Send forespørgsel'}
                    </button>
                  </form>
                </div>
              </div>
            </div>

          </div>
        </section>
      </div>
    );
  }

  if (pageSlug === 'om-os') {
    return (
      <div className="bg-white text-slate-600 min-h-screen">
        {/* Hero Section */}
        <section className="relative min-h-[500px] md:h-[60vh] flex items-center justify-center overflow-hidden">
          <div 
            className="absolute inset-0 bg-cover bg-center bg-no-repeat scale-105"
            style={{ 
              backgroundImage: `url('https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=85,format=auto/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/image_10.png')` 
            }}
          />
          <div className="absolute inset-0 bg-black/50" />

          <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-8 text-center w-full space-y-6 py-16">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-normal uppercase break-words px-4">
              Om os
            </h1>
            <p className="text-[28px] text-slate-200 max-w-3xl mx-auto font-light leading-[1.4]">
              Dan-Team Stainless er en virksomhed med speciale i montage og supervision af procesanlæg indenfor især fødevare og den kemiske industri.
            </p>
            <div className="flex flex-wrap justify-center gap-4 pt-4">
              <Link 
                to="/kontakt" 
                className="bg-[#0073A5] hover:bg-[#005c84] text-white px-8 py-3.5 text-xs font-bold tracking-widest uppercase transition-colors duration-200"
              >
                Kontakt os
              </Link>
              <Link 
                to="/referencer" 
                className="bg-[#0073A5] hover:bg-[#005c84] text-white px-8 py-3.5 text-xs font-bold tracking-widest uppercase transition-colors duration-200"
              >
                Referencer
              </Link>
            </div>
          </div>
        </section>

        {/* Main Content Section */}
        <section className="py-16 sm:py-24 max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 md:gap-16">
            
            {/* Left Column: Main Content */}
            <div className="space-y-8 lg:col-span-8">
              <div className="space-y-6 text-slate-600 font-light leading-relaxed text-base">
                <h2 className="text-2xl md:text-3xl font-bold text-slate-900 tracking-normal uppercase">
                  Om os
                </h2>
                <p>
                  Dan-Team Stainless drives i dag af de to ejere Søren Pedersen &amp; Martin Vedel Bindesbøl, som begge har været i branchen for produktion og montage af rustfrit stål i fødevareindustrien gennem rigtig mange år. Martin står for montage og supervision, mens Søren er leder af værkstedet.
                </p>
                <p>
                  Dan-Team Stainless er en virksomhed med speciale i montage og supervision af procesanlæg indenfor især fødevare og den kemiske industri. Vi tager gerne hele montageopgaven med vores hold af uddannede og certificerede medarbejdere, som arbejder både i Danmark, men som også gennem mange år har haft store montageopgaver rundt i hele verden. Siden Dan-Team Stainless startede i 1999, har vi bygget en lang række forskellige procesanlæg for blandt andet SPX Anhydro, GEA Niro, Gea Liquid Scandinavia, Carlisle Process Systems, Sicca dania, Orkla Foods og Tetra Pak.
                </p>
                <p>
                  Alle medarbejdere er håndplukkede og certificerede efter gældende krav til opgaverne og alle arbejder selvstændigt ud fra tegningsmateriale og PI diagrammer. Derudover er alle medarbejder fortrolige med de strenge krav og standarder, der stilles til hygiejne og finish, indenfor især fødevareindustrien og det er en selvfølge, at alle arbejder for at overholde de kundespecificerede krav. For os er det vigtigt at en montageopgave nås til deadline og at alle krav overholdes og derfor vil mester selv også være med på opgaven som arbejdende supervisor.
                </p>

                {/* First Row of 3 Images */}
                <div className="grid grid-cols-3 gap-4 my-8">
                  <div className="aspect-square overflow-hidden border border-slate-200 shadow-xs bg-slate-50">
                    <img 
                      src="https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/image_13.png" 
                      alt="Montagearbejde 1" 
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <div className="aspect-square overflow-hidden border border-slate-200 shadow-xs bg-slate-50">
                    <img 
                      src="https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/image_14.png" 
                      alt="Montagearbejde 2" 
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <div className="aspect-square overflow-hidden border border-slate-200 shadow-xs bg-slate-50">
                    <img 
                      src="https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/image_15.png" 
                      alt="Montagearbejde 3" 
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                </div>

                <p>
                  Kræver montageopgaven derimod at kunden vil bruge egne håndværkere kan Dan-Team Stainless tilbyde en supervisor til at styre opgaven.
                </p>
                <p>
                  Siden 2009 har Dan-Team Stainless også haft et fuldt udstyret værksted til produktion af blandt andet procesudstyr til fødevareindustrien. Her fremstiller veluddannede medarbejdere alt fra præfabrikerede dele til montageopgaverne, til nøglefærdige units klar til installation samt diverse underleverandørarbejde til adskillige leverandører til fødevareindustrien.
                </p>

                {/* Second Row of 3 Images */}
                <div className="grid grid-cols-3 gap-4 my-8">
                  <div className="aspect-square overflow-hidden border border-slate-200 shadow-xs bg-slate-50">
                    <img 
                      src="https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/image_17.png" 
                      alt="Værkstedsproduktion 1" 
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <div className="aspect-square overflow-hidden border border-slate-200 shadow-xs bg-slate-50">
                    <img 
                      src="https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/image_19.png" 
                      alt="Værkstedsproduktion 2" 
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <div className="aspect-square overflow-hidden border border-slate-200 shadow-xs bg-slate-50">
                    <img 
                      src="https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/image_20.png" 
                      alt="Værkstedsproduktion 3" 
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                </div>

                <h2 className="text-2xl md:text-3xl font-bold text-slate-900 tracking-normal uppercase mt-12">
                  Historie
                </h2>
                <p>
                  Dan-Team Stainless blev grundlagt i 1999 af de to brødre Ib Rasmussen og Kim Rasmussen. I 2014 Indtræder Søren Pedersen som medejer i firmaet efter at have været ansat i firmaet gennem flere år. I januar 2017 fusionerer Dan-Team Stainless med MVB Steel og indehaver Martin Vedel Bindesbøl indtræder som medejer i Dan-Team Stainless.
                </p>

                {/* Third Row of 3 Images (History) */}
                <div className="grid grid-cols-3 gap-4 my-8">
                  <div className="aspect-square overflow-hidden border border-slate-200 shadow-xs bg-slate-50">
                    <img 
                      src="https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/image_21.png" 
                      alt="Historisk projekt Norge 2019" 
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <div className="aspect-square overflow-hidden border border-slate-200 shadow-xs bg-slate-50">
                    <img 
                      src="https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/image_22.png" 
                      alt="Historisk projekt Holland 2018" 
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <div className="aspect-square overflow-hidden border border-slate-200 shadow-xs bg-slate-50">
                    <img 
                      src="https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/image_24.png" 
                      alt="Historisk projekt Holland 2018" 
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                </div>
              </div>

            </div>

            {/* Right Column: Sidebar Card */}
            <div className="lg:col-span-4 lg:sticky lg:top-8 self-start">
              <div className="bg-[#f2f2f2] border border-slate-200 overflow-hidden">
                {/* Header Image */}
                <div className="relative h-48 sm:h-56">
                  <img 
                    src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/image_11.png" 
                    alt="Værksted" 
                    className="w-full h-full object-cover"
                  />
                </div>

                {/* Form & Copy */}
                <div className="p-6 sm:p-8 space-y-6">
                  <div className="space-y-2">
                    <h3 className="text-xl font-bold text-slate-900 uppercase tracking-normal">
                      Få et uforpligtende tilbud
                    </h3>
                    <p className="text-base text-slate-600 font-light leading-relaxed">
                      Kontakt os og få et uforpligtende tilbud på din opgave. Du kan ringe til os på{' '}
                      <a href="tel:+4576991020" className="text-[#0073A5] font-semibold hover:underline">
                        (+45) 76 99 10 20
                      </a>{' '}
                      eller udfylde formularen og vi vil vende tilbage til dig hurtigst muligt.
                    </p>
                  </div>

                  {/* Sidebar Form */}
                  <form onSubmit={handleFormSubmit} className="space-y-4">
                    {/* Honeypot field - ABSOLUTELY HIDDEN from humans */}
                    <div className="sr-only absolute" aria-hidden="true">
                      <label htmlFor="website_url">Website URL</label>
                      <input
                        id="website_url"
                        type="text"
                        name="website_url"
                        value={formData.website_url}
                        onChange={handleInputChange}
                        tabIndex="-1"
                        autoComplete="off"
                      />
                    </div>

                    {/* Name */}
                    <div className="space-y-1">
                      <label htmlFor="name" className="text-[10px] font-bold uppercase tracking-wider text-slate-700">
                        Navn <span className="text-red-500">*</span>
                      </label>
                      <input
                        id="name"
                        type="text"
                        name="name"
                        required
                        value={formData.name}
                        onChange={handleInputChange}
                        className="w-full bg-white border border-slate-300 px-3 py-2 text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-1 focus:ring-sky-500 text-sm"
                        placeholder="Dit navn"
                      />
                    </div>

                    {/* Phone */}
                    <div className="space-y-1">
                      <label htmlFor="phone" className="text-[10px] font-bold uppercase tracking-wider text-slate-700">
                        Telefonnummer <span className="text-red-500">*</span>
                      </label>
                      <input
                        id="phone"
                        type="tel"
                        name="phone"
                        required
                        value={formData.phone}
                        onChange={handleInputChange}
                        className="w-full bg-white border border-slate-300 px-3 py-2 text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-1 focus:ring-sky-500 text-sm"
                        placeholder="Dit telefonnummer"
                      />
                    </div>

                    {/* Email */}
                    <div className="space-y-1">
                      <label htmlFor="email" className="text-[10px] font-bold uppercase tracking-wider text-slate-700">
                        E-mailadresse <span className="text-red-500">*</span>
                      </label>
                      <input
                        id="email"
                        type="email"
                        name="email"
                        required
                        value={formData.email}
                        onChange={handleInputChange}
                        className="w-full bg-white border border-slate-300 px-3 py-2 text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-1 focus:ring-sky-500 text-sm"
                        placeholder="din.email@adresse.dk"
                      />
                    </div>

                    {/* Description */}
                    <div className="space-y-1">
                      <label htmlFor="description" className="text-[10px] font-bold uppercase tracking-wider text-slate-700">
                        Beskrivelse <span className="text-red-500">*</span>
                      </label>
                      <textarea
                        id="description"
                        name="description"
                        required
                        rows="4"
                        value={formData.description}
                        onChange={handleInputChange}
                        className="w-full bg-white border border-slate-300 px-3 py-2 text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-1 focus:ring-sky-500 text-sm resize-none"
                        placeholder="Beskriv dit projekt her..."
                      />
                    </div>

                    {/* Status Messages */}
                    {formStatus.type && (
                      <div className={`p-3 text-xs ${
                        formStatus.type === 'success' 
                          ? 'bg-emerald-500/10 border border-emerald-500/20 text-emerald-600' 
                          : 'bg-red-500/10 border border-red-500/20 text-red-600'
                      }`}>
                        <span>{formStatus.message}</span>
                      </div>
                    )}

                    {/* Submit Button */}
                    <button
                      type="submit"
                      disabled={submitting}
                      className="w-full py-3 bg-[#0073A5] hover:bg-[#005c84] disabled:bg-sky-800 text-white font-bold uppercase text-xs tracking-wider transition-colors duration-200 flex items-center justify-center gap-2 cursor-pointer"
                    >
                      {submitting ? 'Sender...' : 'Send forespørgsel'}
                    </button>
                  </form>
                </div>
              </div>
            </div>

          </div>
        </section>

        {/* Lightbox for Gallery */}
        {lightboxIndex !== null && (
          <Lightbox
            images={gallery}
            currentIndex={lightboxIndex}
            onClose={() => setLightboxIndex(null)}
            onPrev={() => setLightboxIndex((lightboxIndex - 1 + gallery.length) % gallery.length)}
            onNext={() => setLightboxIndex((lightboxIndex + 1) % gallery.length)}
          />
        )}
      </div>
    );
  }

  return (
    <div className="bg-white text-slate-600 min-h-screen">
      {/* Hero Section */}
      <section className="relative h-[45vh] min-h-[300px] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat scale-105"
          style={{ 
            backgroundImage: `url(${page.hero_image?.[0] || 'https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/55dfd408-b442-4dfe-be75-a310b44063dd.jpg'})` 
          }}
        />
        <div className="absolute inset-0 bg-black/45" />


        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center w-full space-y-4">
          <h1 className="text-xl sm:text-3xl lg:text-5xl font-bold text-white tracking-widest break-words px-4">
            {page.title.split(' · ')[0]}
          </h1>
          {isKontaktPage && (
            <p className="text-[28px] text-slate-200 max-w-3xl mx-auto font-light leading-[1.4]">
              Har du spørgsmål eller kommentarer?
            </p>
          )}
        </div>
      </section>

      {/* Main Content Section */}
      <section className={isKontaktPage ? "w-full" : "py-16 sm:py-24 max-w-7xl mx-auto px-6 lg:px-8"}>
        {isKontaktPage ? (
          /* Special Section for Kontakt Page: Split Info & Form Block */
          <div className="w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 overflow-hidden bg-white">
              
              {/* Left Column (50%): Solid primary dark navy block */}
              <div className="bg-[#00364a] text-white p-8 md:p-12 lg:py-24 lg:px-16 flex flex-col justify-center items-center text-center">
                <div className="space-y-6 w-full max-w-xl">
                  <h3 className="text-xl md:text-2xl font-semibold tracking-wide uppercase">
                    Vores informationer
                  </h3>
                  
                  <div className="space-y-4 text-base font-light leading-relaxed text-slate-200">
                    <p className="font-semibold text-white text-base">DAN-TEAM STAINLESS ApS</p>
                    <p>Kurkmarkvej 6, 6093 Sjølund</p>
                    
                    <div className="space-y-2">
                      <p>
                        <a href="tel:+4576991020" className="hover:text-white transition-colors">
                          (+45) 76 99 10 20
                        </a>
                      </p>
                      <p>
                        <a href="mailto:info@dan-team.com" className="hover:text-white transition-colors">
                          info@dan-team.com
                        </a>
                      </p>
                    </div>

                    <div className="space-y-1">
                      <p className="font-semibold text-white">Faktura mail</p>
                      <p>
                        <a href="mailto:invoice@dan-team.com" className="hover:text-white transition-colors">
                          invoice@dan-team.com
                        </a>
                      </p>
                    </div>

                    <div>
                      <p>CVR nr.: 21670405</p>
                    </div>

                    <div className="space-y-1">
                      <p className="font-semibold text-white">Bank</p>
                      <p>Middelfart Sparekasse</p>
                      <p>Reg. nr. 0755</p>
                      <p>Konto. nr. 3234790047</p>
                      <p className="pt-1">IBAN: DK5907553234790047</p>
                      <p>SWIFT code: MISPDK21</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Column (50%): Clean white card container */}
              <div className="bg-white p-8 md:p-12 lg:py-24 lg:px-16 flex flex-col justify-center items-center text-slate-800">
                <form onSubmit={handleFormSubmit} className="space-y-6 w-full max-w-xl">
                  <h3 className="text-xl md:text-2xl font-semibold tracking-wide uppercase text-slate-900 pb-2">
                    Skriv til os
                  </h3>
                  
                  {/* Honeypot field - ABSOLUTELY HIDDEN from humans */}
                  <div className="sr-only absolute" aria-hidden="true">
                    <label htmlFor="website_url">Website URL</label>
                    <input
                      id="website_url"
                      type="text"
                      name="website_url"
                      value={formData.website_url}
                      onChange={handleInputChange}
                      tabIndex="-1"
                      autoComplete="off"
                    />
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Navn */}
                    <div className="space-y-2">
                      <input
                        id="name"
                        type="text"
                        name="name"
                        required
                        value={formData.name}
                        onChange={handleInputChange}
                        className="w-full bg-[#f4f4f4] px-4 py-3 text-slate-900 placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-[#0073A5] text-sm rounded-none border-0"
                        placeholder="Navn *"
                      />
                    </div>

                    {/* Telefonnummer */}
                    <div className="space-y-2">
                      <input
                        id="phone"
                        type="tel"
                        name="phone"
                        required
                        value={formData.phone}
                        onChange={handleInputChange}
                        className="w-full bg-[#f4f4f4] px-4 py-3 text-slate-900 placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-[#0073A5] text-sm rounded-none border-0"
                        placeholder="Tlf. nr. *"
                      />
                    </div>
                  </div>

                  {/* Email */}
                  <div className="space-y-2">
                    <input
                      id="email"
                      type="email"
                      name="email"
                      required
                      value={formData.email}
                      onChange={handleInputChange}
                      className="w-full bg-[#f4f4f4] px-4 py-3 text-slate-900 placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-[#0073A5] text-sm rounded-none border-0"
                      placeholder="Email *"
                    />
                  </div>

                  {/* Besked */}
                  <div className="space-y-2">
                    <textarea
                      id="description"
                      name="description"
                      required
                      rows="6"
                      value={formData.description}
                      onChange={handleInputChange}
                      className="w-full bg-[#f4f4f4] px-4 py-3 text-slate-900 placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-[#0073A5] text-sm rounded-none border-0 resize-none"
                      placeholder="Besked *"
                    />
                  </div>

                  {/* Status Messages */}
                  {formStatus.type && (
                    <div className={`p-4 text-sm ${
                      formStatus.type === 'success' 
                        ? 'bg-emerald-50 border border-emerald-200 text-emerald-800' 
                        : 'bg-red-50 border border-red-200 text-red-800'
                    }`}>
                      <span>{formStatus.message}</span>
                    </div>
                  )}

                  {/* Submit Button */}
                  <div className="pt-2">
                    <button
                      type="submit"
                      disabled={submitting}
                      className="px-8 py-3.5 bg-[#0073A5] hover:bg-[#005c84] disabled:bg-slate-400 text-white font-bold uppercase text-xs tracking-widest transition-colors duration-200 flex items-center justify-center gap-2 cursor-pointer rounded-none"
                    >
                      {submitting ? 'Sender...' : 'Send besked'}
                    </button>
                  </div>

                </form>
              </div>

            </div>

            {/* Vores medarbejdere section */}
            <div className="bg-[#f8f9fa] py-16 sm:py-24 border-t border-slate-100 w-full">
              <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <h2 className="text-2xl md:text-3xl font-normal text-slate-900 tracking-normal text-center mb-12">
                  Vores medarbejdere
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-4xl">
                  {EMPLOYEES.map((emp, idx) => (
                    <div key={idx} className="flex flex-col items-start text-left space-y-2">
                      <div className="w-64 h-64 rounded-none overflow-hidden bg-white border border-slate-200/80 shadow-xs flex items-center justify-center mb-3">
                        <img 
                          src={emp.image.replace('https://assets.auxodev.dk/', 'https://assets.auxodev.dk/cdn-cgi/image/width=500,quality=80,format=auto/')} 
                          alt={emp.name} 
                          className="w-full h-full object-cover"
                          loading="lazy"
                        />
                      </div>
                      <div className="space-y-1 w-full">
                        <h4 className="text-xl md:text-2xl font-semibold text-slate-500">{emp.name}</h4>
                        <hr className="border-t border-slate-200 my-2 w-full" />
                        {emp.role && (
                          <p className="text-base text-slate-600 font-medium pb-2">{emp.role}</p>
                        )}
                      </div>
                      <div className="text-base font-light space-y-1">
                        <p>
                          <a href={`tel:${emp.phoneRaw}`} className="text-[#0073A5] hover:text-[#005c84] font-medium transition-colors">
                            Tlf: {emp.phone}
                          </a>
                        </p>
                        <p>
                          <a href={`mailto:${emp.email}`} className="text-[#0073A5] hover:text-[#005c84] font-medium transition-colors">
                            {emp.email}
                          </a>
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Google Maps section */}
            <div className="w-full h-[450px] relative border-t border-slate-200 bg-slate-100">
              <iframe
                src="https://maps.google.com/maps?q=Kurkmarkvej%206,%206093%20Sj%C3%B8lund&t=&z=15&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="DAN-TEAM Stainless Google Map"
                className="w-full h-full grayscale hover:grayscale-0 transition-all duration-500"
              ></iframe>
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
            
            {/* Left/Main Column: Page Text */}
            <div className="space-y-8 lg:col-span-8">
              <div 
                className="w-full text-slate-600 font-light leading-relaxed
                  [&_p]:text-slate-600 [&_p]:font-light [&_p]:leading-relaxed [&_p]:mb-6
                  [&_h1]:text-3xl [&_h1]:font-bold [&_h1]:text-slate-900 [&_h1]:mt-10 [&_h1]:mb-4 [&_h1]:uppercase [&_h1]:tracking-normal
                  [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:text-slate-900 [&_h2]:mt-8 [&_h2]:mb-4 [&_h2]:uppercase [&_h2]:tracking-normal [&_h2]:border-b [&_h2]:border-slate-200 [&_h2]:pb-2
                  [&_h3]:text-xl [&_h3]:font-bold [&_h3]:text-slate-900 [&_h3]:mt-6 [&_h3]:mb-3 [&_h3]:uppercase [&_h3]:tracking-normal
                  [&_h4]:text-lg [&_h4]:font-bold [&_h4]:text-slate-900 [&_h4]:mt-4 [&_h4]:mb-2 [&_h4]:uppercase [&_h4]:tracking-normal
                  [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2 [&_ul]:mb-6 [&_ul]:text-slate-600 [&_ul]:font-light
                  [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:space-y-2 [&_ol]:mb-6 [&_ol]:text-slate-600 [&_ol]:font-light
                  [&_li]:pl-1
                  [&_strong]:font-semibold [&_strong]:text-slate-900
                  [&_a]:text-[#0073A5] [&_a]:underline [&_a]:hover:text-sky-700"
                dangerouslySetInnerHTML={{ __html: page.content }}
              />

              {/* Associated Gallery Grid */}
              {gallery.length > 0 && (
                <div className="space-y-6 pt-12 border-t border-slate-200">
                  <h3 className="text-2xl font-bold text-slate-900 tracking-normal uppercase">
                    {['om-os', 'referencer'].includes(pageSlug) ? 'Referencer & Partnere' : 'Billedgalleri'}
                  </h3>
                  
                  {pageSlug === 'referencer' ? (
                    /* Logos Container for Referencer */
                    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
                      {gallery.map((img, idx) => (
                        <div 
                          key={idx}
                          className="aspect-video bg-white border border-slate-200 flex items-center justify-center p-3"
                        >
                          <img 
                            src={img} 
                            alt={`Logo ${idx + 1}`} 
                            className="max-h-[85%] max-w-[85%] object-contain"
                            loading="lazy"
                          />
                        </div>
                      ))}
                    </div>
                  ) : (
                    /* Standard Gallery Grid for other pages (including om-os) */
                    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
                      {gallery.map((img, idx) => (
                        <div 
                          key={idx}
                          onClick={() => setLightboxIndex(idx)}
                          className="aspect-square bg-slate-100 border border-slate-200 overflow-hidden cursor-pointer group relative"
                        >
                          <img 
                            src={img} 
                            alt={`Galleri billede ${idx + 1}`} 
                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                            loading="lazy"
                          />
                          <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                            <span className="text-xs text-white uppercase tracking-wider font-semibold bg-sky-950/90 px-4 py-2 border border-sky-900">
                              FØRSTØR
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Right Column: Sidebar */}
            <div className="lg:col-span-4 space-y-8">
              {/* Quick Contact Box */}
              <div className="bg-slate-50 border border-slate-200 p-6 space-y-6">
                <h3 className="text-slate-900 font-bold text-lg tracking-normal border-b border-slate-200 pb-3 uppercase">Hurtig kontakt</h3>
                <p className="text-base text-slate-500 font-light leading-relaxed">
                  Har du spørgsmål eller brug for rådgivning? Ring eller skriv til os i dag.
                </p>
                <div className="space-y-4 text-xs">
                  <a 
                    href="tel:+4576991020" 
                    className="flex items-center gap-3 p-3 bg-white border border-slate-200 hover:border-sky-500 transition-all group"
                  >
                    <Phone className="w-4 h-4 text-sky-500 shrink-0" />
                    <span className="font-semibold text-slate-900 group-hover:text-sky-600 transition-colors whitespace-nowrap">(+45) 76 99 10 20</span>
                  </a>
                  <a 
                    href="mailto:info@dan-team.com" 
                    className="flex items-center gap-3 p-3 bg-white border border-slate-200 hover:border-sky-500 transition-all group"
                  >
                    <Mail className="w-4 h-4 text-sky-500 shrink-0" />
                    <span className="font-semibold text-slate-900 group-hover:text-sky-600 transition-colors whitespace-nowrap">info@dan-team.com</span>
                  </a>
                </div>
              </div>

              {/* Service Navigation */}
              <div className="bg-slate-50 border border-slate-200 p-6 space-y-4">
                <h3 className="text-slate-900 font-bold text-lg tracking-normal border-b border-slate-200 pb-3 uppercase">Vores afdelinger</h3>
                <ul className="space-y-2 text-xs font-medium">
                  <li>
                    <Link to="/vaerkstedet" className="flex items-center justify-between p-2.5 hover:bg-white text-slate-600 hover:text-slate-900 transition-all border border-transparent hover:border-slate-200">
                      <span>Værkstedet</span> <ArrowRight className="w-3.5 h-3.5 text-sky-500" />
                    </Link>
                  </li>
                  <li>
                    <Link to="/montageafd" className="flex items-center justify-between p-2.5 hover:bg-white text-slate-600 hover:text-slate-900 transition-all border border-transparent hover:border-slate-200">
                      <span>Montageafdelingen</span> <ArrowRight className="w-3.5 h-3.5 text-sky-500" />
                    </Link>
                  </li>
                  <li>
                    <Link to="/vandskaering" className="flex items-center justify-between p-2.5 hover:bg-white text-slate-600 hover:text-slate-900 transition-all border border-transparent hover:border-slate-200">
                      <span>Vandskæring</span> <ArrowRight className="w-3.5 h-3.5 text-sky-500" />
                    </Link>
                  </li>
                  <li>
                    <Link to="/referencer" className="flex items-center justify-between p-2.5 hover:bg-white text-slate-600 hover:text-slate-900 transition-all border border-transparent hover:border-slate-200">
                      <span>Referencer</span> <ArrowRight className="w-3.5 h-3.5 text-sky-500" />
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        )}
      </section>

      {/* Lightbox for Gallery */}
      {lightboxIndex !== null && (
        <Lightbox
          images={gallery}
          currentIndex={lightboxIndex}
          onClose={() => setLightboxIndex(null)}
          onNavigate={setLightboxIndex}
        />
      )}
    </div>
  );
}